import { Injectable } from "@angular/core";
import { EventOrgan } from "../../admin/events-screen/create-parent-event-form-pricing-nests/create-parent-event-form-pricing-nests.component";
import { trimTextByWord } from "../../admin/events-screen/utils/trimTextByWord";

@Injectable()
export class AbstractService {
  public getOrgansAsText(organs: EventOrgan[]) {
    if (!organs || organs.length === 0) {
      return "";
    }
    const organsText = organs
      .slice(0, 6)
      .map((organ) => organ.name)
      .join(", ");

    return trimTextByWord(organsText, 27);
  }
  public getLayersAsText(
    layers: Array<{ layerName: string; layerId: number; chosen: boolean }>
  ) {
    if (!layers || layers.length === 0) {
      return "";
    }

    const selectedLayers = layers.filter((l) => l.chosen);
    if (selectedLayers.length === 0) {
      return "";
    }

    const highestLayer = selectedLayers.reduce((prev, current) =>
      prev.layerId > current.layerId ? prev : current
    );
    const lowestLayer = selectedLayers.reduce((prev, current) =>
      prev.layerId < current.layerId ? prev : current
    );
    if (highestLayer.layerId === lowestLayer.layerId) {
      return highestLayer.layerName;
    }
    return `${lowestLayer.layerName} - ${highestLayer.layerName}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/abstract/abstract.service.ts